"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingSessionAttemptSerialization = void 0;
const ChargingTransactionSerialization_1 = require("./ChargingTransactionSerialization");
const MembershipTransactionSerialization_1 = require("./MembershipTransactionSerialization");
const PaymentTransactionSerialization_1 = require("./PaymentTransactionSerialization");
class ChargingSessionAttemptSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.payment_transaction = entity.payment_transaction
            ? JSON.parse(PaymentTransactionSerialization_1.PaymentTransactionSerialization.serialize(entity.payment_transaction))
            : undefined;
        copy.charging_transaction = entity.charging_transaction
            ? JSON.parse(ChargingTransactionSerialization_1.ChargingTransactionSerialization.serialize(entity.charging_transaction))
            : undefined;
        copy.membership_transaction = entity.membership_transaction
            ? JSON.parse(MembershipTransactionSerialization_1.MembershipTransactionSerialization.serialize(entity.membership_transaction))
            : undefined;
        copy.receipt_expires_at = entity.receipt_expires_at
            ? entity.receipt_expires_at.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.payment_transaction = entity.payment_transaction
            ? PaymentTransactionSerialization_1.PaymentTransactionSerialization.deserialize(JSON.stringify(entity.payment_transaction))
            : undefined;
        copy.charging_transaction = entity.charging_transaction
            ? ChargingTransactionSerialization_1.ChargingTransactionSerialization.deserialize(JSON.stringify(entity.charging_transaction))
            : undefined;
        copy.membership_transaction = entity.membership_transaction
            ? MembershipTransactionSerialization_1.MembershipTransactionSerialization.deserialize(JSON.stringify(entity.membership_transaction))
            : undefined;
        copy.receipt_expires_at = entity.receipt_expires_at
            ? new Date(entity.receipt_expires_at / 1000000)
            : undefined;
        return copy;
    }
}
exports.ChargingSessionAttemptSerialization = ChargingSessionAttemptSerialization;
